import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=498b8fff&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=498b8fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b8fff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498b8fff')) {
      api.createRecord('498b8fff', component.options)
    } else {
      api.reload('498b8fff', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=498b8fff&scoped=true&", function () {
      api.rerender('498b8fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27N4qPRNYJIHo/JS/comp/DocBox.vue"
export default component.exports